import Fuse from 'fuse.js'

// ------------------------------------
// Initial State
// ------------------------------------

const state = {
  searchableData: [],
  filteredSearchableData: [],
  displayedSearchableData: [],
  searchableKeys: [],
  query: '',
  searchType: 'NARROW',
  selectedCategories: [],
  pageNumber: 1,
  pageSize: 25
}

// ------------------------------------
// Getters
// ------------------------------------

const getters = {
  searchableData: state => state.searchableData,
  filteredSearchableData: state => state.filteredSearchableData,
  displayedSearchableData: state => state.displayedSearchableData,
  searchableKeys: state => state.searchableKeys,
  query: state => state.query,
  searchType: state => state.searchType,
  pageNumber: state => state.pageNumber,
  pageSize: state => state.pageSize
}

// ------------------------------------
// Constants
// ------------------------------------

const UPDATE_SEARCHABLE_DATA = 'UPDATE_SEARCHABLE_DATA'
const UPDATE_FILTERED_SEARCHABLE_DATA = 'UPDATE_FILTERED_SEARCHABLE_DATA'
const UPDATE_DISPLAYED_SEARCHABLE_DATA = 'UPDATE_DISPLAYED_SEARCHABLE_DATA'
const UPDATE_SEARCHABLE_KEYS = 'UPDATE_SEARCHABLE_KEYS'
const UPDATE_QUERY = 'UPDATE_QUERY'
const UPDATE_SEARCH_TYPE = 'UPDATE_SEARCH_TYPE'
const UPDATE_PAGE_NUMBER = 'UPDATE_PAGE_NUMBER'
const UPDATE_PAGE_SIZE = 'UPDATE_PAGE_SIZE'

// ------------------------------------
// Actions
// ------------------------------------

const actions = {
  async filterSearchableData ({ commit, dispatch, getters }) {
    return dispatch('queryFilter', getters.searchableData)
      .then((filteredSearchableData) => commit('UPDATE_FILTERED_SEARCHABLE_DATA', filteredSearchableData))
      .then(() => dispatch('paginationFilter'))
  },
  async queryFilter ({ getters }, filteredSearchableData) {
    if (!getters.query.trim()) {
      return Promise.resolve(filteredSearchableData)
    }
    let fuse = new Fuse(filteredSearchableData, {
      shouldSort: false,
      tokenize: true,
      matchAllTokens: (getters.searchType === 'NARROW'),
      findAllMatches: true,
      threshold: 0.1,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: getters.searchableKeys
    })
    return Promise.resolve(fuse.search(getters.query))
  },
  async paginationFilter ({ commit, rootGetters }) {
    commit('UPDATE_DISPLAYED_SEARCHABLE_DATA', (rootGetters.pageNumber && rootGetters.pageSize) ? rootGetters.filteredSearchableData : rootGetters.filteredSearchableData.slice((rootGetters.pageNumber - 1) * rootGetters.pageSize, rootGetters.pageNumber * rootGetters.pageSize))
  }
}

// ------------------------------------
// Mutations
// ------------------------------------

const mutations = {
  [UPDATE_SEARCHABLE_DATA] (state, value) {
    state.searchableData = value
  },
  [UPDATE_FILTERED_SEARCHABLE_DATA] (state, value) {
    state.filteredSearchableData = value
  },
  [UPDATE_DISPLAYED_SEARCHABLE_DATA] (state, value) {
    state.displayedSearchableData = value
  },
  [UPDATE_SEARCHABLE_KEYS] (state, value) {
    state.searchableKeys = value
  },
  [UPDATE_QUERY] (state, value) {
    state.query = value
  },
  [UPDATE_SEARCH_TYPE] (state, value) {
    state.searchType = value
  },
  [UPDATE_PAGE_NUMBER] (state, value) {
    state.pageNumber = value
  },
  [UPDATE_PAGE_SIZE] (state, value) {
    state.pageSize = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
